import { render, staticRenderFns } from "./PlatformsCreate.vue?vue&type=template&id=35090835&"
import script from "./PlatformsCreate.vue?vue&type=script&lang=ts&"
export * from "./PlatformsCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports